import React from 'react';
import { Shield, Award, Users, Handshake } from 'lucide-react';

const SoluzioneSection = () => {
  const caratteristiche = [
    {
      icona: Shield,
      titolo: "Cooperativa di Servizi Assicurativi",
      descrizione: "Agenzia Assimoco - Accreditati Eticapro"
    },
    {
      icona: Award,
      titolo: "Società Cooperativa",
      descrizione: "Struttura cooperativa che garantisce approccio mutualistico e condivisione dei valori del Terzo Settore"
    },
    {
      icona: Users,
      titolo: "Società Benefit",
      descrizione: "Impegno certificato per generare beneficio comune oltre al profitto, con impatto positivo su comunità e territorio"
    },
    {
      icona: Handshake,
      titolo: "Competenza Specializzata",
      descrizione: "Esperienza consolidata nell'assistenza ad Enti del Terzo Settore, Cooperative Sociali e Imprese Sociali"
    }
  ];

  return (
    <section id="soluzione" className="py-20 bg-gradient-to-b from-[#3AAFA9]/5 to-white relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#3AAFA9]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#2B7A9F]/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="inline-block px-4 py-2 bg-[#3AAFA9]/10 text-[#2B7A9F] rounded-full text-sm font-semibold mb-4">
            Chi Siamo
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2B7A9F] mb-6">
            Assietica: consulenza etica{' '}
            <span className="text-[#3AAFA9]">per chi fa la differenza</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Non siamo una semplice agenzia assicurativa. Siamo una <strong>Società Cooperativa 
            Società Benefit</strong>, specializzata nella protezione degli ETS e delle Cooperative.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {caratteristiche.map((item, index) => {
            const IconComponent = item.icona;
            return (
              <div
                key={index}
                className="group bg-white rounded-xl p-8 shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-1 border border-gray-100 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className="flex items-start space-x-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#3AAFA9]/20 to-[#2B7A9F]/20 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                    <IconComponent className="text-[#2B7A9F]" size={32} />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#2B7A9F] transition-colors duration-300">
                      {item.titolo}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {item.descrizione}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Value Proposition */}
        <div className="bg-gradient-to-br from-[#2B7A9F] to-[#3AAFA9] rounded-2xl p-8 sm:p-12 text-white shadow-2xl animate-fade-in-up">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6">
                Il nostro approccio: competenza e condivisione
              </h3>
              <div className="space-y-4 text-lg text-white/90">
                <p className="flex items-start space-x-3">
                  <span className="text-[#F9D424] text-2xl flex-shrink-0">✓</span>
                  <span>Consulenza personalizzata basata sulle specificità del Terzo Settore e del mondo Cooperativo</span>
                </p>
                <p className="flex items-start space-x-3">
                  <span className="text-[#F9D424] text-2xl flex-shrink-0">✓</span>
                  <span>Analisi approfondita dei rischi specifici della tua organizzazione</span>
                </p>
                <p className="flex items-start space-x-3">
                  <span className="text-[#F9D424] text-2xl flex-shrink-0">✓</span>
                  <span>Soluzioni assicurative su misura, non prodotti standardizzati</span>
                </p>
                <p className="flex items-start space-x-3">
                  <span className="text-[#F9D424] text-2xl flex-shrink-0">✓</span>
                  <span>Supporto continuo e presenza sul territorio</span>
                </p>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-8 border border-white/20">
              <blockquote className="text-xl italic leading-relaxed mb-4">
                "Siamo persone che vivono il sociale ogni giorno. Con i nostri valori cooperativi e benefit, 
                proteggiamo ETS e Cooperative con soluzioni su misura, perché chi genera impatto positivo 
                merita una tutela costruita attorno alla propria missione."
              </blockquote>
              <p className="font-semibold text-[#F9D424]">— Assietica Società Cooperativa</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SoluzioneSection;
